import { useMemo } from "react";
import { useClientSignUpSteps } from "src/lib/store/hirer-steps-store";

export default function HireNowJobTypeStep({ handleClick }) {
  const { jobType, setJobType } = useClientSignUpSteps();

  const options = useMemo(
    () => [
      { label: "Full-time", value: "fulltime" },
      { label: "Contract", value: "contract" },
    ],
    []
  );

  return (
    <div className="md:w-full w-[340px] ">
      <p className="text-center font-semibold text-lg">Choose Job-type</p>

      <div className="mt-6 rounded-xl border p-5 w-full">
        <div className="w-full flex flex-col md:flex-row items-start justify-start gap-3 md:gap-6">
          {options.map((opt) => {
            const selected = jobType === opt.value;
            return (
              <button
                key={opt.value}
                type="button"
                onClick={() => setJobType(opt.value)}
                className={`w-full rounded-lg border p-6 text-center focus:outline-none focus:ring-2 ring-offset-2 ring-primary ${
                  selected ? "border-primary" : "border-gray-300"
                }`}
              >
                <div className="flex items-center justify-start md:justify-center gap-3 md:gap-6">
                  <div className="border-2 p-3 w-5 h-5 rounded-full relative flex-shrink-0">
                    {selected && (
                      <div className="w-full h-full rounded-full bg-primary" />
                    )}
                  </div>
                  <p className="font-medium">{opt.label}</p>
                </div>
              </button>
            );
          })}
        </div>

        <div className="mt-6 flex justify-end">
          <button
            type="button"
            disabled={!jobType}
            onClick={() => handleClick("next")}
            className="bg-primary text-white rounded-md px-6 py-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}